import React from "react";
import moment from "moment";
import { Row, Col, Table, Image } from 'react-bootstrap';
import Barcode from 'react-barcode';
import { COLOR_APP, COLOR_WHITE, S3_URL } from '../../constants';
import logoMain from "../../image/logo_main.png";
import QRCode from "react-qr-code";
import { checkLogoLogictics, convertLogicticsName, convertPriceWithCommission, numberFormat } from '../../helpers';
import _ from "lodash";
import { billReceiverAddress, billReceiverBranch, billReceiverName, billReceiverTel, billSenderAddress, billSenderBranch, billShipments, billShipmentPayType, billCodNumber, BILL_SHIPMENT_PAY_TYPE_LABEL } from "./billDestination";
export default class BillOrder100x150 extends React.PureComponent {
    render() {
        const { data: orderDatas, rateData } = this.props;
        const ITEMS_PER_PAGE = 10;

        if (_.isEmpty(orderDatas)) return <p>Not Data...!!</p>

        return (
            <div>
                {orderDatas.map((item, index) => {
                    const totalPages = Math.ceil(item?.orders.length / ITEMS_PER_PAGE);

                    return Array.from({ length: totalPages }).map((_, pageIndex) => {
                        const startIndex = pageIndex * ITEMS_PER_PAGE;
                        const endIndex = startIndex + ITEMS_PER_PAGE;
                        const currentOrders = item?.orders.slice(startIndex, endIndex);
                        // console.log("orderdelivery: -> ",item?.orderDelivery)

                        return (
                            <div key={`${index}-${pageIndex}`} style={styles.sectionStyle}>
                                {/* Logistics Section */}
                                {this.renderLogistics(item)}

                                {/* Order Information */}
                                {/* {this.renderOrderInfo(item)} */}

                                {/* Header Section */}
                                {this.renderHeader(item)}

                                <hr />
                                <Row>
                                    <Col>
                                        <div style={{ padding: 10, fontSize: 37, fontWeight: 'bold', color: "#333", opacity: 0.8 }}>
                                            {BILL_SHIPMENT_PAY_TYPE_LABEL[billShipmentPayType(item)]}
                                        </div>
                                        <div style={{ padding: 8 }}>
                                            <p style={{ fontSize: 27 }}>{moment(item?.orderDelivery?.createdAt).format('DD/MM/YYYY HH:mm')}</p>

                                            <p style={{ fontSize: 27 }}>
                                                1x1x1cm | 1kg
                                                {/* {Array.isArray(item?.orderDelivery?.parcels) && item.orderDelivery.parcels.length > 0
                                                    ? `${item.orderDelivery.parcels[0].width ?? 1}x${item.orderDelivery.parcels[0].length ?? 1}x${item.orderDelivery.parcels[0].height ?? 1} | ${item.orderDelivery.parcels[0].weight ?? 1}kg`
                                                    : '1x1x1 | 1kg'} */}
                                            </p>

                                        </div>
                                    </Col>
                                    <Col>
                                        <div style={{ display: 'flex', paddingTop: 10, flexDirection: 'column', justifyContent: 'center', alignItems: 'end', width: '100%', borderLeft: "2px solid #777" }}>
                                            <p style={{ fontSize: 32, fontWeight: 'bold', width: 340, display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%' }}>ເງິນຝາກ: {item?.orderDelivery?.totalShippingFree > 0 ? numberFormat(item?.orderDelivery?.totalShippingFree ?? 0) : "......................."} ກີບ</p>
                                            <p style={{ fontSize: 32, fontWeight: 'bold', width: 340, display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%' }}>COD: ....................... ກີບ</p>
                                            <p style={{ fontSize: 32, fontWeight: 'bold', width: 340, display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%' }}>ເງິນລວມ: {item?.orderDelivery?.totalShippingFree > 0 ? numberFormat(item?.orderDelivery?.totalShippingFree ?? 0) : "......................."} ກີບ</p>
                                        </div>
                                    </Col>
                                </Row>
                                <hr />
                                <h6 style={{ opacity: 0.5 }}>ໝາຍເຫດ: ຄ່າຝາກນີ້ບໍ່ແນ່ນອນ ບາງທິອາດຈະມີການປ່ຽນແປງໄປຕາມຂົນສົ່ງຄິດໄລ່ໃຫ້</h6>


                            </div>
                        );
                    });
                })}
            </div>
        );
    }

    renderHeader(item) {
        return (
            <div className="mb-3 d-flex justify-content-between align-items-center" style={{ borderTop: '2px solid #778', padding: '8px 0' }}>
                <Image src={`${S3_URL}${item?.shop?.image}`} alt={item?.shop?.name} style={styles.imageStyle} roundedCircle />
                <div>
                    <h5 style={{ fontSize: 32, fontWeight: 'bold' }}>ຈ່າຍຄ່າເຄື່ອງ: {item?.orderDelivery?.shipmentPayType === "COD" ? "ປາຍທາງ" : "ຕົ້ນທາງ"}</h5>
                    {item?.orderDelivery?.shipmentPayType === "COD" && <h5 style={{ fontSize: 28, fontWeight: 'bold' }}>ຄ່າເຄື່ອງ (ບໍ່ລວມຄ່າຝາກ): 35.000 ກີບ</h5>}
                </div>
                <div className="d-flex gap-2 justify-content-end">
                    {item?.orderDelivery?.deliveryTackingNo &&
                        <QRCode
                            size={256}
                            style={{ height: "auto", maxWidth: 120, width: "100%" }}
                            value={item?.orderDelivery?.deliveryTackingNo}
                            viewBox={`0 0 256 256`}
                        />
                    }
                </div>
            </div>
        );
    }

    renderOrderInfo(item) {
        return (
            <div className="w-100 d-flex justify-content-between">
                <div>
                    <p style={styles.textLarge}>ເລກບິນ:</p>
                    <p style={styles.textSmall}>ວັນທີ,ເດືອນ,ປີ:</p>
                </div>
                <div className="d-flex justify-content-center align-items-end flex-column">
                    <p style={styles.textLarge}>{item?.code}</p>
                    <p style={styles.textSmall}>{moment(item?.createdAt).format('DD/MM/YYYY HH:mm')}</p>
                </div>
            </div>
        );
    }

    renderTotal(item, taxPrice, shopRate) {
        return (
            <tr>
                <td style={styles.totalLabel}>ຍອດລວມ</td>
                <td colSpan={2} style={styles.totalAmount}>
                    ₭{numberFormat(convertPriceWithCommission(item?.totalPrice, item?.sumPriceBaht, item?.sumPriceUsd, taxPrice, shopRate))}
                </td>
            </tr>
        );
    }

    renderLogistics(item) {
        const shippMentsBody = billShipments(item)
        return (
            <div>
                <div className="d-flex justify-content-between mt-3">
                    {item?.orderDelivery?.delivery && <div className="d-flex flex-column justify-content-center align-items-center">
                        <Image src={checkLogoLogictics(item?.orderDelivery?.delivery)} style={styles.imageStyle} roundedCircle />
                        <p style={{ fontSize: 37 }}>{convertLogicticsName(item?.orderDelivery?.delivery)} ຂົນສົ່ງດ່ວນ</p>
                    </div>
                    }
                    <div style={styles.barcodeContainer}>
                        <Barcode value={item?.orderDelivery?.deliveryTackingNo ?? "No_Tracking_Number"} height={110} fontSize={32} />
                    </div>
                    <div className="d-flex flex-column justify-content-center align-items-center">
                        <Image src={logoMain} alt="brand-logo" style={{ width: 125, height: 125, border: '1px solid #ddd', borderRadius: 25 }} />
                        <p style={{ fontSize: 37 }}>Super CF</p>
                    </div>
                </div>
                <div style={{ borderTop: '2px solid #778' }}>
                    <p style={styles.textLarge}>ຜູ້ຝາກ: {item?.orderDelivery?.sender?.fullName ?? item?.shop?.name}</p>
                    <p style={styles.textLarge}>ເບີໂທ: {item?.orderDelivery?.sender?.tel ?? item?.shop?.phone}, &nbsp; ລະຫັດ COD: {billCodNumber(item) || "......"}</p>
                    <p style={styles.textLarge}>ທີ່ຢູ່: {billSenderAddress(item, this.props.shopData)}</p>
                    <p style={styles.textLarge}>ສາຂາຕົ້ນທາງ: {billSenderBranch(item, this.props.shopData)}</p>
                </div>
                <div style={{ borderTop: '2px solid #778' }}>
                    <p style={styles.textLarge}>ຜູ້ຮັບ: {billReceiverName(item)}</p>
                    <p style={styles.textLarge}>ເບີໂທ: {billReceiverTel(item)}</p>
                    <p style={styles.textLarge}>ທີ່ຢູ່: {billReceiverAddress(item)}</p>
                    <div className="d-flex justify-content-between align-items-center w-100" style={{ background: "#333", color: COLOR_WHITE, }}>
                        <p style={{ padding: 10, fontWeight: 'bold', fontSize: 42 }}>
                            ສາຂາປາຍທາງ: {billReceiverBranch(item)}
                        </p>
                        <p style={{ padding: 10, fontWeight: 'bold', fontSize: 42 }}>
                            {shippMentsBody?.data?.warehouse ?? ""}
                        </p>
                    </div>
                </div>



            </div>
        );
    }
}

const styles = {
    sectionStyle: { breakInside: "avoid", padding: '3em' },
    imageStyle: { width: 125, height: 125, border: '1px solid #ddd' },
    tableStyle: { minHeight: "26vh" },
    tableHeader: { padding: 4, fontSize: 37 },
    tableData: { fontSize: 37, padding: 4 },
    textLarge: { fontSize: 32 },
    textSmall: { marginTop: '-.5em', fontSize: 37 },
    totalLabel: { fontSize: 40, fontWeight: 'bold' },
    totalAmount: { textAlign: 'right', paddingTop: 10, fontSize: 40, fontWeight: 'bold' },
    barcodeContainer: { maxWidth: 500, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: "center" },
    logisticsTitle: { fontSize: 32, fontWeight: 'bold' },
    routeTitle: { fontSize: 40 },
    headerTitle: { fontSize: 40, fontWeight: 'bold' },
};

